import React from 'react';

import { renderRoutes as policyRoutes } from './routes/policies.routes';
// import { renderRoutes as groupRoutes } from './routes/groups.routes';

export const renderRoutes = () => {
  return policyRoutes()
}
